export default (hasSubmenu) => ({
  state: false,
  hasSubmenu,
  trigger() {
    this.state = !this.state;
  },
  onClick(e) {
    if (this.hasSubmenu) {
      e.preventDefault();
      this.trigger();
    }
  },
  onMouseEnter() {
    if (!this.$store.responsive.isMobile && this.hasSubmenu) {
      this.state = true;
    }
  },
  onMouseLeave() {
    if (!this.$store.responsive.isMobile && this.hasSubmenu) {
      this.state = false;
    }
  },
  init() {},
});
